import React from "react";
import SubpageLine from "../assets/SubpageLine";

function AproachBlock({ points, title, intro }) {
    return (
        <div className="bgwhite">
            <div className="aproach-block container-fluid py ">
                <div className='row intro'>
                    <div className='col-xl-4 col-lg-6'>
                        <span className='eyebrow'>Okkar nálgun</span>
                        <h2 className='light title'>{title}</h2>
                        <p className="p-body-2 thin">{intro}</p>
                    </div>
                    <div className="col-lg-6 offset-xl-1 offset-lg-0 circle position-relative">
                        <SubpageLine />
                    </div>
                </div>
                <div className="row">
                    {points.map((point, index) => (
                        <div key={index} className="col-xl-4 col-lg-6 col-md-6 point mb-48">
                            <span className="font-suisse-thin">0{index + 1}</span>
                            <h4 className="point-name light mb-24">{point.title}</h4>
                            {point.text && (<div className="point-text p-body-2 thin" dangerouslySetInnerHTML={{ __html: point.text }} />)}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AproachBlock;
